import { useNavigate } from 'react-router-dom';
import Spinner from '../Spinner';
import { SimulatorFormContainer } from './SimulationComponents/SimulationMuiComponents';
import SimulatorFormFunds from './SimulatorFormFunds';

const SimulatorRendersFunds = ({
  setSend,
  formData,
  setFormData,
  securitySelected,
  doGetSimulatorList,
  loadingSimulationFunds,
  setFormDataAndPersist,
}) => {
  const navigate = useNavigate();

  const yearsToMonths = {
    '6 meses': 6,
    '1 año': 12,
    '2 años': 24,
    '3 años': 36,
    '5 años': 60,
  };

  const handleSubmit = async values => {
    try {
      if (setFormDataAndPersist) {
        await setFormDataAndPersist(values);
      } else {
        setFormData(values);
        localStorage.setItem(
          'investmentInitial',
          JSON.stringify({
            initialInvestment: values.initialInvestment ?? '',
            monthlyInvestment: values.monthlyInvestment ?? '',
            months: values.months ?? '1 año',
          }),
        );
      }

      localStorage.setItem('fundsSimulationData', JSON.stringify(values));

      setFormData(values);

      doGetSimulatorList({
        variables: {
          data: {
            ...values,
            securityId: securitySelected.ID,
            initialInvestment: Number.parseInt(values.initialInvestment?.replace(/\D/g, '')),
            monthlyInvestment: Number.parseInt(values.monthlyInvestment?.replace(/\D/g, ''))
              ? Number.parseInt(values.monthlyInvestment?.replace(/\D/g, ''))
              : 0,
            months: yearsToMonths[values.months],
          },
        },
      });

      setSend(true);
      navigate(`/simulator/result/${securitySelected.ID}`);
    } catch (e) {
      console.error('handleSubmit error:', e);
    }
  };

  return (
    <>
      <SimulatorFormContainer>
        <SimulatorFormFunds
          formData={formData}
          handleSubmit={handleSubmit}
          loadingSimulationFunds={loadingSimulationFunds}
          securitySelected={securitySelected}
        />
      </SimulatorFormContainer>
    </>
  );
};

export default SimulatorRendersFunds;
